/* CRO 2026-11-04 – Free Mesh Pouch 15x20 with GoLivUP Travel Pillow Plus (approved by Tay).
   Owner: CRO agent. Own file; loaded from sections/cro-plus-gift.liquid (header group).
   Pairs with the automatic discount "Free Mesh Pouch with Travel Pillow Plus" (100% off 1 x 15x20 pouch).
   Rules: Plus in cart + no 15x20 pouch -> add 1 x Black 15x20 with _gift=plus-pouch.
          No Plus -> remove the auto-added pouch. Never more than one. Customer removal is respected. */
(function () {
  'use strict';
  if (window.__croPlusGift) return; window.__croPlusGift = true;
  var PLUS_PRODUCT = 8529633345583;
  var GIFT_VARIANT = 47120364339247;                          /* Black / 15 x 20 cm */
  var POUCH_15 = [47120364273711, 47120364306479, 47120364339247]; /* any 15x20 colour */
  var PROP = '_gift', PROP_VAL = 'plus-pouch';
  var SS_DECLINED = 'croPlusGiftDeclined', SS_LAST = 'croPlusGiftLast', SS_RELOAD = 'croPlusGiftReload';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false, again = false;

  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function json(url, body) {
    return nativeFetch(root + url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cro-plus-gift ' + url + ' ' + r.status); return r.json(); });
  }
  function isGift(i) { return i.properties && i.properties[PROP] === PROP_VAL; }
  function state(cart) {
    var plus = 0, any15 = 0, gifts = [];
    cart.items.forEach(function (i, idx) {
      if (i.product_id === PLUS_PRODUCT) plus += i.quantity;
      if (POUCH_15.indexOf(i.variant_id) > -1) any15 += i.quantity;
      if (isGift(i)) gifts.push({ key: i.key, qty: i.quantity });
    });
    return { plus: plus, any15: any15, gifts: gifts };
  }
  function change(key, qty) { return json('cart/change.js', { id: key, quantity: qty }); }

  /* Returns a promise resolving to true if the cart was changed. */
  function reconcile() {
    if (busy) { again = true; return Promise.resolve(false); }
    busy = true;
    var changed = false;
    return json('cart.js').then(function (cart) {
      var s = state(cart), last = ss(SS_LAST);
      /* Customer removed the gift while keeping the Plus: respect it this session. */
      if (last === 'plus+gift' && s.plus > 0 && s.gifts.length === 0) ss(SS_DECLINED, '1');
      if (s.plus === 0) ss(SS_DECLINED, null);
      var p = Promise.resolve();
      if (s.plus === 0 && s.gifts.length) {
        s.gifts.forEach(function (g) { p = p.then(function () { changed = true; return change(g.key, 0); }); });
      } else if (s.plus > 0) {
        s.gifts.forEach(function (g, n) {
          var want = n === 0 ? 1 : 0;
          if (g.qty !== want) p = p.then(function () { changed = true; return change(g.key, want); });
        });
        if (s.any15 === 0 && !ss(SS_DECLINED)) {
          p = p.then(function () { changed = true; return json('cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1, properties: { _gift: PROP_VAL } }] }); });
        }
      }
      return p.then(function () { return changed ? json('cart.js') : cart; }).then(function (c2) {
        var s2 = state(c2); ss(SS_LAST, s2.plus > 0 ? (s2.gifts.length ? 'plus+gift' : 'plus') : 'none');
        if (changed) document.dispatchEvent(new CustomEvent('cro:plus-gift:changed', { detail: { cart: c2 } }));
        return changed;
      });
    }).catch(function (e) { if (window.console) console.warn(e && e.message ? e.message : e); return false; })
      .then(function (ch) { busy = false; if (again) { again = false; return reconcile().then(function (c) { return ch || c; }); } return ch; });
  }

  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function refreshIfNeeded(changed) {
    if (!changed) return;
    if (onCartPage()) {
      var n = parseInt(ss(SS_RELOAD) || '0', 10);
      if (n < 3) { ss(SS_RELOAD, String(n + 1)); location.reload(); }
    } else {
      json('cart.js').then(function (c) {
        document.querySelectorAll('a[href$="/cart"][aria-label^="Cart"]').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + c.item_count + ' items'); });
        document.querySelectorAll('[data-cart-count], .hu-cart-count, .cart-count-bubble span[aria-hidden]').forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
    }
  }

  /* Watch any cart write made through fetch (theme cart page, apps). */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var res = nativeFetch(input, init);
    if (CART_WRITE.test(url)) {
      res.then(function () { setTimeout(function () { reconcile().then(refreshIfNeeded); }, 0); }, function () {});
    }
    return res;
  };

  /* Product form for the Plus (main button and sticky bar both submit #hu-pdp-form): add both in one go, then go to the cart like the native form. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || e.defaultPrevented) return;
    var pid = f.querySelector('input[name="product-id"]');
    if (!pid || parseInt(pid.value, 10) !== PLUS_PRODUCT) return;
    e.preventDefault();
    var fid = f.getAttribute('id');
    var btns = Array.prototype.slice.call(f.querySelectorAll('button[type="submit"]'));
    if (fid && window.CSS && CSS.escape) btns = btns.concat(Array.prototype.slice.call(document.querySelectorAll('button[type="submit"][form="' + CSS.escape(fid) + '"]')));
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    var fd = new FormData(f);
    nativeFetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { ss(SS_DECLINED, null); return reconcile(); })
      .then(function () { location.href = root + 'cart'; })
      .catch(function () { btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); }); HTMLFormElement.prototype.submit.call(f); });
  }, false);

  /* On every page load (covers native /cart/add, /cart/change links and other tabs). */
  function boot() { reconcile().then(function (ch) { if (!ch) ss(SS_RELOAD, null); refreshIfNeeded(ch); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
